/* IntelApps — Discuss CTA Section */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Arrow } from './Header.js';
import { useI18n } from '../i18n.js';

function DiscussTitle({ html }) {
  // eslint-disable-next-line react/no-danger
  return <h2 style={{ marginTop: 12 }} dangerouslySetInnerHTML={{ __html: html }} />;
}

DiscussTitle.propTypes = {
  html: PropTypes.string.isRequired,
};

export default function DiscussCTA() {
  const { t } = useI18n();

  return (
    <section className="section" style={{ paddingTop: 0 }}>
      <div className="container">
        <div className="discuss">
          <div className="discuss-grid">
            <div>
              <span className="eyebrow">{t.discuss.eyebrow}</span>
              <DiscussTitle html={t.discuss.title} />
              <p className="discuss-lede">{t.discuss.description}</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <Link to="/discuss-project" className="btn btn-accent btn-arrow">{t.discuss.cta} <Arrow size={14} /></Link>
              <a href={`mailto:${t.discuss.email}`} className="btn btn-ghost" style={{ color: '#fff', borderColor: 'rgba(255,255,255,0.2)' }}>{t.discuss.email}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
